<template>
  <div class="b-foot-impressum">
    <a href="#" @click.prevent="toggle">Impressum</a>
    <div :class="[{'is-active': isActive}, 'modal']">
      <div class="modal-background" @click="close"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Impressum</p>
        </header>
        <section class="modal-card-body">
          <strong>bringe Informationstechnik GmbH</strong>
          <br>
          <br>
          <table>
            <tr>
              <td>
                <fa icon="map-marker-alt" fixed-width></fa>
              </td>
              <td>Rudolf-Link-Strasse 6</td>
            </tr>
            <tr>
              <td></td>
              <td>76228 Karlsruhe</td>
            </tr>
            <tr>
              <td>
                <fa icon="phone-alt" fixed-width></fa>
              </td>
              <td>+49 721 94246 – 0</td>
            </tr>
            <tr>
              <td>
                <fa icon="fax" fixed-width></fa>
              </td>
              <td>+49 721 94246 – 66</td>
            </tr>
            <tr>
              <td>
                <fa icon="envelope" fixed-width></fa>
              </td>
              <td>info@bringe.com</td>
            </tr>
          </table>
          <p>
            <br>
            Vertretungsberechtigte Geschäftsführer: Dipl.-Ing. (FH) Martin Bringe, Lars Bringe B.Sc.
            <br>
            <br>
            Registergericht: Amtsgericht Mannheim
            <br>
            Registernummer: HRB 108943
            <br>
            <br>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE 812936645
            <br>
            <br>
            Inhaltlich Verantwortlicher gemäß §5 DDG: Dipl.-Ing. (FH) Martin Bringe (Anschrift wie oben)
          </p>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="close">Schliessen</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BFootImpressum',
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },
    close() {
      this.isActive = false;
    },
  },
}
</script>

<style lang="scss" scoped>
  .b-foot-impressum {
    display: inline;
    text-align: left;
    .modal-card-body {
      td {
        padding: .1em .5em 0 0;
      }
    }
  }
</style>
